export const WPM_MIN = 80;
export const WPM_MAX = 250;
export const WPM_DEFAULT = 150;

export const WPM_PRESETS = [
  { label: 'Slow', value: 120 },
  { label: 'Normal', value: 150 },
  { label: 'Fast', value: 180 },
] as const;

export type WpmPreset = (typeof WPM_PRESETS)[number];
